const Vue = require("vue").default

function moneyFunc(value, t) {
    let v = isNaN(Math.abs(value)) ? 0 : parseFloat(value)
    var n = Math.trunc(v * 100) / 100,
        /*   var n = parseInt(value),  */
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? '\u0020' : t,
        /* s = n <= 0 ? "" : "+", */
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

//приводит число к "финансовому" виду
Vue.filter('f', moneyFunc)
Vue.filter('fin', moneyFunc)